import React from 'react';
import { Box, SxProps, Theme, Typography } from '@evaneos/b2b-ui';

type BlockProps = {
    title: React.ReactNode;
    /** Optional content displayed in the header below the title (e.g., warnings, actions) */
    headerContent?: React.ReactNode;
    /** The main content of the block (list, empty state, etc.) */
    children: React.ReactNode;
    sx?: SxProps<Theme>;
};

export const Block = ({ title, headerContent, children, sx }: BlockProps) => (
    <Box
        component="section"
        display="flex"
        flexDirection="column"
        sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            borderRadius: '8px',
            ...sx,
        }}
    >
        <Box padding={3} paddingBottom={1.5} borderBottom="1px solid" borderColor="divider">
            <Typography variant="h3" fontWeight={800}>
                {title}
            </Typography>
            {headerContent}
        </Box>
        {children}
    </Box>
);
